/**
 * #1113 T7 item 3: why the Tracker's Edit can't be used now. An edit ends by
 * placing a replacement, so it needs the account ready, able to submit, and
 * allowed to place the order's side (the same rule as `canPlace` in
 * UsPortfolioWorkspace, which derives `canPlace` from this). Null when Edit
 * is usable. The row offers Edit only where a cancel is possible, which an
 * unavailable account refuses, so the not-ready sentence is the contract's
 * wording for any caller that offers Edit without a cancel; the row never
 * shows it today.
 */
import { usReason } from '@/lib/polymarketUs/reason';
import type { UsReadiness } from '@/lib/polymarketUs/types';

export function usEditUnavailableReason(
  readiness: UsReadiness,
  permissions: { buy: boolean; sell: boolean },
  side: 'buy' | 'sell',
): string | null {
  if (readiness.state !== 'ready') return `Edit unavailable: ${usReason(readiness.reason)}`;
  if (readiness.canSubmit && permissions[side]) return null;
  return `Edit unavailable: placing a ${side.toUpperCase()} isn't available on this account now`;
}
